export default __webpack_public_path__ + "static/media/check_icon.d3f54e5f.svg";